<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ payroll.allowance_penalty_type.name.toUpperCase() }}</b> allowance? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      payroll: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.salaryDetails().destroy(this.payroll.id)
          .then(res => {
            if (res.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: 'Allowance succesfully deleted' })
              this.menu = false
              this.progressing = false
            }
          }).catch(() => {
            this.$snack({ 
              color: 'error',
              message: 'Failed to delete allowance', 
            })
          })
      },
    },
  }
</script>
